import React from 'react';
import { makeDate } from './data.jsx';
import { Icon } from './icons.jsx';
import { StatusBadge } from './shell.jsx';
// Drawer de histórico de faturas de assinatura — Super Admin Tezus
const InvoicesDrawer = ({ open, store, onClose, onToast, logAction }) => {
  if (!open || !store) return null;

  const invoices = React.useMemo(() => {
    if (!store) return [];
    const list = [];
    const today = makeDate(0);
    const months = Math.min(8, Math.max(1, Math.round((today - store.createdAt) / (30 * 86400000)) + 1));

    for (let i = 0; i < months; i++) {
      const dueDate = new Date(today);
      dueDate.setMonth(dueDate.getMonth() - i);
      dueDate.setDate(15);

      let status;
      if      (i === 0 && store.status === 'inadimplente') status = 'falhou';
      else if (i === 0 && (store.status === 'trial' || store.status === 'suspenso')) status = 'pendente';
      else if (i === 1 && store.status === 'inadimplente') status = 'pendente';
      else                                                  status = 'paga';

      list.push({
        id:      `inv_${store.id}_${i}`,
        date:    dueDate,
        valor:   store.plan.price,
        status,
        periodo: dueDate.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }),
      });
    }
    return list;
  }, [store]);

  const handleReenviar = (inv) => {
    if (onToast)   onToast(`Fatura de ${inv.periodo} reenviada para ${store.ownerEmail || store.name}`);
    if (logAction) logAction({ acao: `Reenviou fatura (${inv.periodo})`, loja: store.name, lojaId: store.id, kind: 'info' });
  };

  const fmtBRL = (v) => 'R$ ' + Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 });

  const STATUS = {
    paga:     { label: 'Paga',     cls: 'success' },
    pendente: { label: 'Pendente', cls: 'warning' },
    falhou:   { label: 'Falhou',   cls: 'danger'  },
  };

  const totalPago = invoices.filter(i => i.status === 'paga').reduce((a, b) => a + b.valor, 0);

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="drawer" style={{ width: 500 }}>
        {/* Head */}
        <div className="drawer-head">
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', color: 'var(--info)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="trending" size={18} />
          </div>
          <div style={{ flex: 1 }}>
            <h3>Histórico de faturas</h3>
            <div className="sub">{store.name} · plano {store.plan.name} · {invoices.length} fatura{invoices.length !== 1 ? 's' : ''}</div>
          </div>
          <button className="icon-action" onClick={onClose} style={{ width: 32, height: 32 }}>
            <Icon name="x" size={16} />
          </button>
        </div>

        {/* Resumo */}
        <div style={{ padding: '12px 20px', background: 'var(--bg-subtle)', borderBottom: '1px solid var(--border)', display: 'flex', gap: 24, fontSize: 13 }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 2 }}>Total recebido</div>
            <div style={{ fontWeight: 600, color: 'var(--success)' }}>{fmtBRL(totalPago)}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 2 }}>Plano atual</div>
            <div style={{ fontWeight: 600 }}>{store.plan.name} · {fmtBRL(store.plan.price)}/mês</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 2 }}>Status da conta</div>
            <div><StatusBadge status={store.status} /></div>
          </div>
        </div>

        {/* Tabela */}
        <div className="drawer-body" style={{ padding: 0 }}>
          {invoices.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>
              <Icon name="check" size={24} style={{ display: 'block', margin: '0 auto 10px', opacity: 0.4 }} />
              Nenhuma fatura encontrada
            </div>
          ) : (
            <table className="data">
              <thead>
                <tr>
                  <th>Período</th>
                  <th>Vencimento</th>
                  <th style={{ textAlign: 'right' }}>Valor</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'right' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map(inv => {
                  const s = STATUS[inv.status];
                  return (
                    <tr key={inv.id}>
                      <td>
                        <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>{inv.periodo}</div>
                      </td>
                      <td style={{ color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>
                        {inv.date.toLocaleDateString('pt-BR')}
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmtBRL(inv.valor)}</td>
                      <td>
                        <span className={`badge ${s.cls}`}>
                          <span className="dot"></span>{s.label}
                        </span>
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        {(inv.status === 'pendente' || inv.status === 'falhou') && (
                          <button className="btn sm" onClick={() => handleReenviar(inv)}>
                            <Icon name="refresh" size={12} />Reenviar
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* Footer */}
        <div className="drawer-foot">
          <span className="note">Faturas geradas automaticamente pela plataforma Tezus.</span>
          <button className="btn ghost" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </>
  );
};

export {
  InvoicesDrawer,
};
